// The order of every list of users, operators, teams, templates and customers
// that has no other obvious order: alphabetical, ignoring case (product owner,
// 2026-10-09). See web/CLAUDE.md, "Lists are alphabetical".
//
// Firestore's `orderBy('team_name')` is not this order: it puts every capital
// before every lower-case letter, so "Zone B" sorts above "anchor team". Sort
// here, after the read.

const text = (value) => (value == null ? '' : String(value)).trim();

// "Team 2" before "Team 10", "anna" next to "Anna".
export const compareNames = (a, b) =>
  text(a).localeCompare(text(b), undefined, { sensitivity: 'base', numeric: true });

// The name a record is listed under. The same kind of record is spelled
// differently depending on where it was read (Firestore or the API).
export const displayName = (item) => {
  if (item == null) return '';
  if (typeof item === 'string') return item;
  return text(
    item.name || item.operator_name || item.operatorName || item.team_name
    || item.template_name || item.display_name || item.displayName
    || item.label || item.title || item.email || item.id
  );
};

// A sorted copy. `nameOf` picks the text to sort on when `displayName` would
// pick the wrong field.
export const sortByName = (list, nameOf = displayName) =>
  [...(list || [])].sort((a, b) => compareNames(nameOf(a), nameOf(b)));
